<template>
  <div class="entry">
    <b-container class="page-container">
      <b-row>
        <b-col md="1"></b-col>
        <h1 class="title" v-if="entries[0]">{{ entries[0].title }}</h1>
      </b-row>
      <b-row>
        <b-col md="1"></b-col>
        <h6 class="indent" v-if="entries[0]"><font-awesome-icon :icon="['far', 'clock']"/> {{entries[0].displayDate}}</h6>
      </b-row>
      <b-row>
        <b-col md="1"></b-col>
        <b-breadcrumb :items="items"/>
      </b-row>
      <hr>
      <h1 v-if="loading">
        <font-awesome-icon :icon="['fas', 'circle-notch']" class="fa-spin"/>
      </h1>
      <ul id="no-bullet" v-if="!loading">
        <li v-for="content in contents" :key="content.contentId">
          <entry-preface v-if="content.templateId == 5" :contentId="content.contentId" :title="content.title" :text="content.text" :graphic="content.graphic"></entry-preface>
          <entry-post v-else-if="content.templateId == 1" :contentId="content.contentId" :title="content.title" :text="content.text" :graphic="content.graphic"></entry-post>
          <entry-list v-else-if="content.templateId == 3" :contentId="content.contentId" :title="content.title" :text="content.text" :graphic="content.graphic" :list="content.listItems"></entry-list>
          <entry-skill v-else-if="content.templateId == 2" :contentId="content.contentId" :title="content.title" :text="content.text" :graphic="content.graphic" :icon="content.icon"></entry-skill>
          <entry-video v-else-if="content.templateId == 6" :contentId="content.contentId" :title="content.title" :text="content.text" :graphic="content.graphic"></entry-video>
          <!-- <log-entry :entryId="entry.entryId" :title="entry.title" :summary="entry.summary" :graphic="entry.graphic" :displayDate="entry.displayDate" :createdBy="entry.createdBy"></log-entry> -->
          <hr>
        </li>
      </ul>
      <br>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios'
import EntryPreface from '../components/EntryPreface.vue'
import EntryPost from '../components/EntryPost.vue'
import EntryList from '../components/EntryList.vue'
import EntrySkill from '../components/EntrySkill.vue'
import EntryVideo from '../components/EntryVideo.vue'

export default {
  name: 'entry',
  components: {
    EntryPreface,
    EntryPost,
    EntryList,
    EntrySkill,
    EntryVideo
  },
  data () {
    return {
      entries: [],
      contents: [],
      items: [
        {text: 'Home', to: '/'},
        {text: 'Devlopment Log', to: '/log'}
      ],
      loading: true
    }
  },
  methods: {
    getEntry: function (id) {
      axios.get('http://bargoapi.finitegames.com/api/finitegames/getEntryById/' + id)
        .then((response) => {
          this.entries = response.data.Entries
          this.items.push({text: this.entries[0].title, active: true})
        }, (error) => {
          console.log(error)
        })
    },
    getContents: function (id) {
      axios.get('http://bargoapi.finitegames.com/api/finitegames/getContentByEntryId/' + id)
        .then((response) => {
          this.contents = response.data.Contents
          this.loading = false
        }, (error) => {
          console.log(error)
          this.loading = false
        })
    }

  },
  beforeMount () {
    this.getEntry(this.$route.params.entryId)
    this.getContents(this.$route.params.entryId)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Entry.vue